// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { useLocation } from 'react-router-dom';

function AgentPage() {
  const location = useLocation();

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>Agent Health Details</h1>
      <p style={{ fontSize: '18px', color: '#666', marginTop: '20px' }}>
        Current Route:{' '}
        <code style={{ background: '#f0f0f0', padding: '4px 8px', borderRadius: '4px' }}>
          {location.pathname}
        </code>
      </p>
      <p style={{ color: '#999', marginTop: '40px' }}>
        This page will show detailed agent health monitoring.
      </p>
    </div>
  );
}

export default AgentPage;
